import api from './api';

/**
 * Auswertung der Kampagnen.
 *
 * Die Zahlen stammen aus Tagesstaenden, die ein Job mitschreibt -- Lemlist
 * selbst fuehrt keine Historie und gibt nur den Augenblickswert heraus.
 */

export interface Quoten {
  nichtZugestellt: number | null;
  /** Bei LinkedIn-Kampagnen immer null -- das Feld traegt dort etwas anderes. */
  geoeffnet: number | null;
  geantwortet: number | null;
  klicks: number | null;
  abgemeldet: number | null;
}

export interface Hinweis {
  art: 'zustellung' | 'oeffnung' | 'klicks' | 'ruecklauf';
  schwere: 'warnung' | 'hinweis';
  text: string;
}

export interface Zahlen {
  leadTotal: number;
  sentCount: number;
  deliveredCount: number;
  openedCount: number;
  clickedCount: number;
  repliedCount: number;
  interestedCount: number;
  bouncedCount: number;
  unsubscribedCount: number;
  outOfOfficeCount: number;
}

export interface Veraenderung {
  versendet: number;
  zugestellt: number;
  geantwortet: number;
  nichtZugestelltPunkte: number | null;
}

export interface Zeile {
  lemlistCampaignId: string;
  name: string;
  status: string | null;
  kanal: string;
  tag: string;
  zahlen: Zahlen;
  quoten: Quoten;
  hinweise: Hinweis[];
  veraenderung: Veraenderung | null;
}

export interface Uebersicht {
  zeilen: Zeile[];
  summe: {
    email: { versendet: number; zugestellt: number; geoeffnet: number; geantwortet: number };
    linkedin: { versendet: number; zugestellt: number; geantwortet: number };
  };
  stand: string | null;
}

export interface SammelBilanz {
  kampagnen: number;
  geschrieben: number;
  ohneZahlen: number;
  fehler: string[];
}

/** Prozent mit einer Nachkommastelle; Gedankenstrich, wo nichts zu rechnen war. */
export const alsProzent = (wert: number | null | undefined): string =>
  wert === null || wert === undefined ? '–' : `${(wert * 100).toFixed(1)} %`;

const auswertungService = {
  async uebersicht(auchLeere = false): Promise<Uebersicht> {
    const response = await api.get('/auswertung', { params: auchLeere ? { auchLeere: '1' } : {} });
    return response.data;
  },

  /**
   * Holt die Zahlen frisch bei Lemlist. Bewusst eine ausdrueckliche
   * Handlung: es sind ueber 40 Abrufe, die dort in die Ratenbegrenzung
   * laufen, wenn sie bei jedem Seitenaufruf mitliefen.
   */
  async sammeln(): Promise<SammelBilanz> {
    const response = await api.post('/auswertung/sammeln');
    return response.data;
  },

  async verlauf(id: string): Promise<{ staende: Array<Zahlen & { tag: string; quoten: Quoten }> }> {
    const response = await api.get(`/auswertung/${id}/verlauf`);
    return response.data;
  },
};

export default auswertungService;
